var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "delete-btns-content" }, [
    _c(
      "div",
      {
        class:
          _vm.showBatchDel && _vm.showDelBtn
            ? "delete-btns-show"
            : "delete-btns-hide"
      },
      [
        _c(
          "button",
          {
            staticClass: "cancel-btn",
            on: {
              click: function($event) {
                return _vm.cancel()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "delete-btn",
            attrs: { disabled: _vm.size < 1 },
            on: {
              click: function($event) {
                return _vm.openDeleteDialog()
              }
            }
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t("language.common.delete") +
                  (_vm.size > 0 ? "(" + _vm.size + ")" : "")
              )
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a84be95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a84be95","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_delete_btns.vue
// module id = null
// module chunks = 